module.exports = __webpack_public_path__ + "img/reports_icon_pink.3630af5e.svg";